exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filas-checkbox-lista[data-v-9d062148] {\n  overflow-y: auto;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  padding: 6px 10px;\n  background: #fff;\n}\n", ""]);

// exports
